import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { register, verifyotp } from "../store/slices/auth";
import { useDispatch, } from "react-redux";

import logo from "../assets/logo.png";
import "../Login.css";

export default function Register() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [form, setForm] = useState({
        name: "",
        email: "",
        mobileNumber: "",
        referralCode: "",
        password: "",
    });

    const [showOtpModal, setShowOtpModal] =
        useState(false);

    const [otp, setOtp] = useState("");

    const [userId, setUserId] =
        useState("");

    const [errors, setErrors] = useState({
        name: "",
        email: "",
        mobileNumber: "",
        referralCode: "",
        password: "",
        otp: "",
    });
    const [showPw, setShowPw] = useState(false);
    const [loading, setLoading] = useState(false);
    const [logoErr, setLogoErr] = useState(false);


    const validateField = (name, value) => {

        let error = "";
        if (name === "name") {

            if (!value.trim()) {

                error = "Please enter name";

            } else if (value.trim().length < 3) {

                error = "Minimum 3 characters";

            } else if (!/^[A-Za-z\s]+$/.test(value)) {

                error =
                    "Only alphabets allowed";
            }
        }

        // EMAIL
        if (name === "email") {

            if (!value.trim()) {

                error = "Please enter email";

            } else if (
                !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
            ) {

                error = "Please enter valid email";
            }
        }

        // MOBILE
        if (name === "mobileNumber") {

            if (!value.trim()) {

                error = "Please enter mobile number";

            } else if (
                !/^[6-9]\d{9}$/.test(value)
            ) {

                error = "Enter valid 10 digit mobile number";
            }
        }

        // REFERRAL
        if (name === "referralCode") {

            if (!value.trim()) {

                error =
                    "Please enter referral code";
            }
        }

        // PASSWORD
        if (name === "password") {

            if (!value.trim()) {

                error =
                    "Please enter password";

            } else if (value.length < 6) {

                error =
                    "Minimum 6 characters";

            } else if (value.length > 25) {

                error =
                    "Maximum 25 characters";

            } else if (
                !/^(?=.*[A-Za-z])(?=.*\d).+$/.test(value)
            ) {

                error =
                    "Password must contain letters and numbers";
            }
        }

        // OTP
        if (name === "otp") {

            if (!value.trim()) {

                error = "Please enter OTP";

            } else if (
                !/^\d{6}$/.test(value)
            ) {

                error =
                    "OTP must be 6 digits";
            }
        }

        return error;
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const ref = params.get("ref");

        if (ref) {
            setForm((prev) => ({
                ...prev,
                referralCode: ref,
            }));
        }
    }, []);

    const handleChange = (e) => {

        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: validateField(name, value),
        }));
    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        const newErrors = {

            name: validateField(
                "name",
                form.name
            ),

            email: validateField(
                "email",
                form.email
            ),

            mobileNumber: validateField(
                "mobileNumber",
                form.mobileNumber
            ),

            referralCode: validateField(
                "referralCode",
                form.referralCode
            ),

            password: validateField(
                "password",
                form.password
            ),
        };

        setErrors(newErrors);

        if (
            Object.values(newErrors).some(
                (err) => err
            )
        ) {
            return;
        }
        try {

            setLoading(true);

            const response = await dispatch(
                register({
                    name: form.name,
                    email: form.email,
                    mobileNumber: form.mobileNumber,
                    referralCode: form.referralCode,
                    password: form.password,
                })
            ).unwrap();

            setUserId(
                response?.data?.userId
            );

            setShowOtpModal(true);

        } catch (error) {

            console.log(error);

            alert(
                error || "Registration failed"
            );

        } finally {

            setLoading(false);
        }
    };

    const handleVerifyOtp = async () => {

        try {

            setLoading(true);

            await dispatch(
                verifyotp({
                    userId,
                    otp
                })
            ).unwrap();

            alert("OTP Verified");

            navigate("/");

        } catch (error) {

            alert(
                error || "OTP verification failed"
            );

        } finally {

            setLoading(false);
        }
    };
    return (
        <>


            <div className="sar-page">

                <div className="sar-card">

                    {/* LOGO */}

                    <div className="sar-logo-wrap">

                        <div className="sar-logo-img-box">

                            {logoErr ? (

                                <span className="sar-logo-fallback">
                                    CB
                                </span>

                            ) : (

                                <img
                                    src={logo}
                                    alt="logo"
                                    className="sar-logo-img"
                                    onError={() => setLogoErr(true)}
                                />

                            )}

                        </div>

                        <div className="sar-brand">
                            Cash Back Promoters and Developers
                        </div>


                    </div>

                    <div className="sar-accent-line"></div>

                    {/* TITLE */}

                    <div className="sar-form-title mb-3">
                        Register
                    </div>




                    <form onSubmit={handleSubmit}>




                        {/* NAME */}

                        <input
                            type="text"
                            name="name"
                            placeholder="Enter Name"
                            value={form.name}
                            onChange={handleChange}
                            className="sar-input "
                        />
                        {errors.name && (
                            <div className="sar-input-error">
                                {errors.name}
                            </div>
                        )}
                        <input
                            type="email"
                            name="email"
                            placeholder="Enter Email"
                            value={form.email}
                            onChange={handleChange}
                            className="sar-input mt-3"
                        />
                        {errors.email && (
                            <div className="sar-input-error">
                                {errors.email}
                            </div>
                        )}

                        <input
                            type="text"
                            name="mobileNumber"
                            placeholder="Enter Mobile Number"
                            value={form.mobileNumber}
                            onChange={handleChange}
                            className="sar-input mt-2"
                        />
                        {errors.mobileNumber && (
                            <div className="sar-input-error">
                                {errors.mobileNumber}
                            </div>
                        )}
                        {/* REFERRAL */}

                        <input
                            type="text"
                            name="referralCode"
                            placeholder="Enter Referral Code"
                            value={form.referralCode}
                            onChange={handleChange}
                            className="sar-input mt-2"
                        />

                        {errors.referralCode && (
                            <div className="sar-input-error">
                                {errors.referralCode}
                            </div>
                        )}


                        <input
                            type={showPw ? "text" : "password"}
                            name="password"
                            placeholder="Enter password"
                            value={form.password}
                            onChange={handleChange}
                            disabled={loading}
                            className={`sar-input mt-2 ${errors.password ? "sar-input-invalid" : ""}`}
                            maxLength={25}
                        />



                        {errors.password && (

                            <div className="sar-input-error">
                                {errors.password}
                            </div>

                        )}


                        <button
                            type="submit"
                            className="sar-btn mt-3"
                            disabled={loading}
                        >

                            {loading ? (

                                <>
                                    <Spinner
                                        animation="border"
                                        size="sm"
                                        style={{
                                            marginRight: 8
                                        }}
                                    />

                                    Please wait...

                                </>

                            ) : (

                                "Submit"

                            )}

                        </button>

                    </form>

                    {/* REGISTER LINK */}

                    <div className="sar-register">

                        Already have an account?{" "}

                        <span
                            onClick={() => navigate("/")}
                            className="sar-register-link"
                        >
                            Login
                        </span>

                    </div>

                </div>

            </div>

            {showOtpModal && (

                <div className="otp-modal">

                    <div className="otp-box">

                        <h4>Verify OTP</h4>

                        <input
                            type="text"
                            placeholder="Enter OTP"
                            value={otp}
                            onChange={(e) =>
                                setOtp(e.target.value)
                            }
                            className="sar-input mb-5"
                        />

                        <button
                            className="sar-btn"
                            onClick={handleVerifyOtp}
                        >
                            Verify OTP
                        </button>

                    </div>

                </div>

            )}
        </>
    );
}